var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCassiopeiaBadgeHasReferredRibbon = function SvgCassiopeiaBadgeHasReferredRibbon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.506,
    height: 18.449,
    viewBox: "0 0 6.484 4.881",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.34 4.437) scale(.26456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.775-15.205h1.762V-.039h-1.762z",
    style: {
      opacity: 1,
      fill: "#5a4800",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.61875,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 1.5,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.656,
    cy: -0.544,
    r: 1.725,
    style: {
      opacity: 1,
      fill: "#d1a600",
      fillOpacity: 1,
      stroke: "#5a4800",
      strokeWidth: 1.00008,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 1.5,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.656,
    cy: -7.545,
    r: 1.725,
    style: {
      fill: "#d1a600",
      fillOpacity: 1,
      stroke: "#5a4800",
      strokeWidth: 1.00008,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 1.5,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.656,
    cy: -14.545,
    r: 1.725,
    style: {
      fill: "#d1a600",
      fillOpacity: 1,
      stroke: "#5a4800",
      strokeWidth: 1.00008,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 1.5,
      strokeOpacity: 1
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCassiopeiaBadgeHasReferredRibbon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cassiopeia-badge-has-referred-ribbon.19ee724e1ea903427c1a1ef7c6d3af8e.svg";